import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Button, Radio, Space, Table } from 'antd';
import { TableCard, } from 'components';
import { includes, number as lNumber } from 'libs';
import store from './store';
import { Action } from 'components';
import moment from "moment";
// import styles from './index.module.less';

export default observer(function () {
  const [rowrecords, setrowRecords] = useState({});
  const [isdisabled, setDisabled] = useState(true)
  const [data, setData] = useState([])
  const [columns, setColumns] = useState([])

  useEffect(()=>{
    setData(store.records)
    console.log(store.records);
  },[store.records])

  useEffect(()=>{
    let allColumn = [];
    if (store.f_type === 'Sale') {
      allColumn = [...defaultColumns,...columns1];
    }else if(store.f_type === 'Rent'){
      allColumn = [...defaultColumns,...columns2];
    }else{
      allColumn = [...defaultColumns,...columns3];
    }
    setColumns(allColumn);
  },[store.f_type])

  // function handleChange(e) {
  //   store.records = [];
  //   store.page = 1
  //   store.f_type = e.target.value;
  //   setrowRecords({});
  //   store.fetchRecords();
  // };
  //公共表头
  const defaultColumns = [{
    title: '下单日期',
    width: '120px',
    dataIndex: 'orderCreatedAt',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  },{
    title: '发货日期',
    width:120,
    dataIndex: 'sendDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  },{
    title: '物流单号',
    width: '150px',
    ellipsis:true,
    dataIndex: 'expressNo'
  }, {
    title: '申请人',
    width: '80px',
    dataIndex: 'applyUserName',
  }, {
    title: '项目号',
    width: '120px',
    dataIndex: 'projectNo',
  }, {
    title: '医院名称',
    width: '120px',
    ellipsis:true,
    dataIndex: 'hospitalName',
  }, {
    title: '中心号',
    width: '120px',
    dataIndex: 'centerNo',
  }, {
    title: 'PO号',
    width: '120px',
    dataIndex: 'purchaseNo',
  }, {
    title: '设备名称',
    width: '150px',
    ellipsis:true,
    dataIndex: 'productName',
  }, {
    title: '品牌',
    width: '150px',
    ellipsis:true,
    dataIndex: 'brandName',
  }, {
    title: '货号',
    width: '120px',
    ellipsis:true,
    dataIndex: 'factoryCode'
  }, {
    title: '序列号',
    width: '120px',
    dataIndex: 'deviceSerialNo'
  }, {
    title: '发票抬头',
    width:200,
    dataIndex: 'invoiceTitle',
  },]
// 销售设备表头
  const columns1 = [{
    title: '联系人',
    width: '80px',
    dataIndex: 'name'
  }, {
    title: '手机号',
    width: '120px',
    dataIndex: 'phone'
  }, {
    title: '发货地址',
    width: '150px',
    ellipsis:true,
    dataIndex: 'address',
  }, {
    title: '校准结束日期',
    width: '120px',
    dataIndex: 'certEndDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  },{
    title: '操作',
    width: '100px',
    fixed:"right",
    render: info => (
      <Action>
        <Action.Button onClick={() => store.showForm(info)}><span style={{ fontSize: '0.0625rem' }}>查看详情</span></Action.Button>
      </Action>
    )
  },]
// 租赁设备表头
  const columns2 = [{
    title: '当前投放点',
    width: '120px',
    ellipsis:true,
    dataIndex: 'hospitalAddress'
  }, {
    title: '租期',
    width: '80px',
    dataIndex: 'rentMonth',
    render:(val)=>{
      if (val) {
        return `${val}个月`
      }
    }
  }, {
    title: '起租日期',
    width: '120px',
    dataIndex: 'startDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  }, {
    title: '到期日期',
    width: '120px',
    dataIndex: 'endDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  },{
    title: '退租日期',
    width: '120px',
    dataIndex: 'exitDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  },{
    title: '校准结束日期',
    width: '120px',
    dataIndex: 'certEndDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  },
  // {
  //   title: '租赁到期日期',
  //   width: '120px',
  //   dataIndex: 'noticeDate',
  //   render: (info)=>{
  //     if (info) {
  //       return moment(info).format("YYYY-MM-DD")
  //     }
  //     return null
  //   }
  // },
  {
    title: '操作',
    width: '100px',
    fixed:"right",
    render: info => (
      <Action>
        <Action.Button onClick={() => store.showForm(info)}><span style={{ fontSize: '0.0625rem' }}>查看详情</span></Action.Button>
      </Action>
    )
  },]
  // 仓储设备表头
  const columns3 = [{
    title: '取货联系人',
    width: '120px',
    dataIndex: 'name'
  },{
    title: '取货手机号',
    width: '120px',
    dataIndex: 'phone'
  },{
    title: '取货地址',
    width: '150px',
    ellipsis:true,
    dataIndex: 'address'
  },{
    title: '存放地点',
    width: '120px',
    ellipsis:true,
    dataIndex: 'storeName'
  }, {
    title: '校准结束日期',
    width: '120px',
    dataIndex: 'certEndDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  }, {
    title: '操作',
    width: '100px',
    fixed:"right",
    render: info => (
      <Action>
        <Action.Button onClick={() => store.showForm(info)}><span style={{ fontSize: '0.0625rem' }}>查看详情</span></Action.Button>
      </Action>
    )
  },]

  return (
    <React.Fragment>
      <Table
        rowKey="id"
        loading={store.fetching}
        bordered
        dataSource={data}
        columns={columns}
        scroll={{ x: 100, }}
        pagination={{
          showSizeChanger: true,
          showLessItems: true,
          current: store.page,
          pageSize: store.pageSize,
          total: store.pageTotal,
          showTotal: total => `共 ${total} 条`,
          pageSizeOptions: ['10', '20', '50', '100'],
          onChange: store.pageChange
        }}
        onReload={store.fetchRecords}
        // actions={[
        //   <Space style={{ marginRight: 10 }}>
        //   <Radio.Group disabled={store.fetching === true} value={store.f_type} onChange={handleChange}>
        //     <Radio.Button value="Sale">销售设备</Radio.Button>
        //     <Radio.Button value="Rent">租赁设备</Radio.Button>
        //     <Radio.Button value="Store">仓储设备</Radio.Button>
        //   </Radio.Group>
        // </Space>
        // ]}
      />
    </React.Fragment>
  )

})
